import { render, staticRenderFns } from "./GroupTag.vue?vue&type=template&id=1ab23ff8&scoped=true&"
import script from "./GroupTag.vue?vue&type=script&lang=js&"
export * from "./GroupTag.vue?vue&type=script&lang=js&"
import style0 from "./GroupTag.vue?vue&type=style&index=0&id=1ab23ff8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab23ff8",
  null
  
)

export default component.exports